module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"add":"Создать подборку вакансий","h1":"Новая подборка вакансий","cancel":"Отмена"}}')
  delete Component.options._Ctor
}
